export const NAMESPACE = "PortalHomeCalendarCardModel";

export const GROUP_BY_IDS = {
  ALL: "all",
  TASKS: "tasks",
  EVENTS: "events"
};

export const GROUP_BY = [
  { id: GROUP_BY_IDS.ALL, text: "All", selected: true },
  { id: GROUP_BY_IDS.TASKS, text: "Tasks", selected: false },
  { id: GROUP_BY_IDS.EVENTS, text: "Events", selected: false }
];

export const SEARCH_BAR_INSTANCE_ID_CALENDAR_HOME_SECTION =
  "SEARCH_BAR_INSTANCE_ID_CALENDAR_HOME_SECTION";
